// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  version: '1.0.0',
  // serverUrl: 'http://172.24.4.83:3000/api/v1/' //elgi live,
  // serverUrl: 'http://52.172.249.41:5000/api/v1/'

 //  serverUrl: 'http://192.168.0.182:3000/api/v1/' //test
  //  serverUrl: 'http://52.172.249.41:3005/api/v1/',
  // serverUrl: 'http://192.168.0.182:3000/api/v1/',
    //  serverUrl: 'http://103.130.88.112:3001/api/v1/',
    // serverUrl: 'http://52.172.249.41:3005/api/v1/',
    // serverUrl:'https://demo2api.yantra24x7.com/api/v1/'

//     serverUrl:'http://4.224.82.109:8008/api/v1/',
//  serverUrl1:`4.224.82.109:8008`


// serverUrl:'http://4.224.82.109:3000/api/v1/',
// serverUrl1:`4.224.82.109:3000`

// serverUrl1:`${window.location.hostname}:${Number(window.location.port) - 2}`,
// serverUrl: `${window.location.protocol}//${window.location.hostname}:${Number(window.location.port) - 2}/api/v1/`,//elgi demo,
// serverType:"Local"

    // serverUrl:'http://4.224.82.109:6003/api/v1/',
    // serverUrl1:`4.224.82.109:6003`,
    // serverType:"Local"
    // serverUrl:'http://20.244.36.18:5001/api/v1/',
    // serverUrl1:`http://20.244.36.18:5001/`, 
    // serverUrl2:`http://20.244.36.18:5002/`, 
    // grafanaUrl:'http://demo.yantra24x7.com:3000/',
    // serverType:"Local"
    // 
    //  serverUrl:'http://20.235.246.38:3000/api/v1/',
    //  serverUrl1:`http://20.235.246.38:3000/`, 
    //  serverUrl2:`http://20.244.36.18:5002/`, 
    //  grafanaUrl:'http://demo.yantra24x7.com:3000/',
    //  serverType:"Local"
    serverUrl1:`${window.location.hostname}:${Number(window.location.port) - 2}`,
    serverUrl: `${window.location.protocol}//${window.location.hostname}:${Number(window.location.port) - 2}/api/v1/`,//elgi demo,
    serverUrl2: `${window.location.protocol}//${window.location.hostname}:${Number(window.location.port) - 1}/`, // Insights download
    grafanaUrl:'http://demo.yantra24x7.com:3000/',
    serverType:"Local"
  //  serverUrl:'http://20.244.36.18:7011/api/v1/',
  //   serverUrl1:`20.244.36.18:7011`
    // serverUrl1:`${window.location.hostname}:3005`,
    // serverUrl:`${window.location.protocol + '//' + window.location.hostname}:3005/api/v1/`,
    // serverType:"Local"//elgi demo
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
